export default __webpack_public_path__ + "static/media/img-4.a27d2e94.png";